import { base64Bytes, saveBase64 } from '../../lib/mail.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- file-preview-dialog ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    container: { type: String, required: true },
    mailbox: String,
    files: Array,
    index: { type: Number, default: 0 },
  }

  init(props) {
    this.state.index = props.index
    this.state.loading = true
    this.state.error = ''
    this.state.url = ''
    this.state.cache = {}
    // Headless and some mobile browsers have no built-in PDF viewer; an iframe would stay blank.
    this.state.pdfViewer = navigator.pdfViewerEnabled !== false
    this.on(document, 'keydown', (event) => {
      if (event.key === 'ArrowLeft') this.step(-1)
      else if (event.key === 'ArrowRight') this.step(1)
    })
  }

  onMount() {
    this.load()
  }

  onDestroy() {
    for (const entry of Object.values(this.state.cache)) URL.revokeObjectURL(entry.url)
  }

  current() {
    return this.props.files[this.state.index]
  }

  async load() {
    const file = this.current()
    if (!file) return
    window.Dialog.setTitle(file.label)
    this.state.error = ''
    if (this.state.cache[file.id]) {
      this.state.url = this.state.cache[file.id].url
      this.state.loading = false
      return
    }
    this.state.loading = true
    try {
      const result = await window.App.api(`container/${this.props.container}/file`, { file: file.id, mailbox: this.props.mailbox || undefined }, { silent: true })
      const url = URL.createObjectURL(new Blob([base64Bytes(result.data)], { type: file.preview.type }))
      this.state.cache = { ...this.state.cache, [file.id]: { url, data: result.data } }
      if (this.current().id === file.id) this.state.url = url
    } catch (error) {
      this.state.error = error.message
    } finally {
      this.state.loading = false
    }
  }

  step(delta) {
    const next = this.state.index + delta
    if (next < 0 || next >= this.props.files.length) return
    this.state.index = next
    this.load()
  }

  download() {
    const file = this.current()
    const cached = this.state.cache[file.id]
    if (cached) saveBase64(cached.data, file.label, file.preview.type)
  }

  beforeRender() {
    const file = this.current() || {}
    this.state.file = file
    this.state.kind = file.preview?.kind || ''
    this.state.many = this.props.files.length > 1
    this.state.position = `${this.state.index + 1} of ${this.props.files.length}`
    this.state.hasPrev = this.state.index > 0
    this.state.hasNext = this.state.index < this.props.files.length - 1
  }

  CSS = `:fez {
display:block;.preview-stage{display:grid;place-items:center;height:min(72vh,820px);border:1px solid var(--color-border);border-radius:var(--radius-lg);background:var(--color-bg-subtle);overflow:hidden}.preview-image{max-width:100%;max-height:100%;object-fit:contain}.preview-pdf{width:100%;height:100%;border:0}.preview-bar{display:flex;align-items:center;gap:var(--space-2);margin-top:var(--space-4)}.preview-meta{flex:1;min-width:0;overflow:hidden;color:var(--color-text-muted);font-size:var(--text-sm);text-overflow:ellipsis;white-space:nowrap}
}`

  HTML = `<div class="preview-stage">
{#if state.error}
<ui-empty icon="warning-circle" title="Could not open this file" text={state.error}></ui-empty>
{:else if state.loading}
<ui-spinner></ui-spinner>
{:else if state.kind === 'pdf' && !state.pdfViewer}
<ui-empty icon="file-pdf" title="This browser does not show PDFs" text="Download the file to open it."></ui-empty>
{:else if state.kind === 'pdf'}
<iframe class="preview-pdf" title={state.file.label} src={state.url}></iframe>
{:else}
<img class="preview-image" src={state.url} alt={state.file.label} />
{/if}
</div>
<div class="preview-bar">
<span class="preview-meta">{state.file.meta}{state.many ? \` · \${state.position}\` : ''}</span>
{#if state.many}
<ui-button size="sm" variant="ghost" icon="caret-left" title="Previous" disabled={!state.hasPrev} onclick="fez.step(-1)"></ui-button>
<ui-button size="sm" variant="ghost" icon="caret-right" title="Next" disabled={!state.hasNext} onclick="fez.step(1)"></ui-button>
{/if}
<ui-button size="sm" icon="download-simple" label="Download" disabled={state.loading || Boolean(state.error)} onclick="fez.download()"></ui-button>
</div>`
};
}

Fez('file-preview-dialog', __fez_component_0);

export default __fez_component_0;
